<template>
    <div class="yudo-repair">
        <van-form>
            <van-field v-model="attrs.person" name="person" label="维修人员" label-align="right" placeholder="维修人员" required />
            <van-field readonly clickable :value="attrs.type" name="type" label="维修类型" label-align="right" placeholder="维修类型" required @click="onAction('type', types, '维修类型')" />
            <van-field v-model="attrs.remark" name="remark" rows="2" autosize type="textarea" maxlength="150" show-word-limit label="维修备注" label-align="right" placeholder="维修备注" />
            <div style="padding: 16px">
                <van-button block type="primary" @click="onSubmit">提&nbsp;&nbsp;交</van-button>
            </div>
            <!-- 快速单选 -->
            <van-action-sheet v-model="actions.show" :actions="actions.columns" :description="actions.desc" close-on-click-action @select="onSelectAction" />
        </van-form>
    </div>
</template>
<script>
import { Dialog } from 'vant';
import { add } from '@/api/form';

export default {
    data() {
        return {
            qrcode: {}, // 二维码
            // tpl: {},
            fid: 10, // 表单ID
            attrs: {
                person: '',
                type: '',
                remark: '',
            },
            // 单选选择器
            actions: {
                show: false,
                columns: [],
                desc: '描述信息',
                attr: '',
            },
            // 维修类型
            types: [{ name: '返厂' }, { name: '替换配件' }, { name: '手动维修' }, { name: '其它' }],
        };
    },
    mounted() {
        this.qrcode = this.$store.state.qrcode;
    },
    methods: {
        // 提交表单
        onSubmit() {
            // 判断维修人员
            if (this.attrs.person == '') {
                Dialog.alert({
                    title: '提交验证',
                    message: '维修人员不能为空',
                });
                return;
            }
            // 判断维修类型
            if (this.attrs.type == '') {
                Dialog.alert({
                    title: '提交验证',
                    message: '维修类型不能为空',
                });
                return;
            }
            add(this.fid, this.attrs, this.qrcode.id).then((res) => {
                Dialog.alert({
                    title: '操作提示',
                    message: '添加维修记录成功',
                }).then(() => {
                    // 跳转预览
                    this.$router.replace({ name: 'QRCode', params: { code: this.qrcode.serial }, query: { token: this.$store.state.token } });
                });
            });
            // const attrs = { ...this.attrs }; // 复制attrs
            // // 组装数据
            // let data = new FormData();
            // data.append('fid', this.fid);
            // data.append('attrs', JSON.stringify(attrs));
            // data.append('qr_id', this.id);
            // axios
            //     .request({
            //         url: HOST + '/form/add_record',
            //         method: 'post',
            //         headers: { Authorization: this.token },
            //         data,
            //     })
            //     .then((res) => {
            //         const { code, msg, data } = res.data;
            //         if (code == 200) {
            //             vant.Dialog.alert({
            //                 title: '操作提示',
            //                 message: '添加维修记录成功',
            //             }).then(() => {
            //                 // 跳转预览
            //                 location.replace('./index.html?act=page&id=' + this.id + '&tpl=' + this.tpl + '&token=' + this.token);
            //             });
            //         } else {
            //             vant.Dialog.alert({
            //                 title: '请求错误',
            //                 message: msg,
            //             });
            //         }
            //     });
        },
        // 单选
        onAction(attr, columns, desc) {
            this.actions = { ...this.actions, show: true, desc, attr, columns };
        },
        // 单选确认
        onSelectAction(item) {
            this.attrs[this.actions.attr] = item.name;
        },
    },
};
</script>
<style lang="less" scoped>
.yudo-repair {
    padding: 16px;
    background-color: #fff;
}
</style>